import apiClient from "./axios"

export const getAccountLoanStatusList = async (params = {}) => {
  const { data } = await apiClient.get("/account-loan-statuses", { params })
  return data
}

export const getAccountLoanStatusById = async id => {
  const { data } = await apiClient.get(`/account-loan-statuses/${id}`)
  return data
}

export const createAccountLoanStatus = async payload => {
  const { data } = await apiClient.post("/account-loan-statuses", payload)
  return data
}

export const updateAccountLoanStatus = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-loan-statuses/${id}`, payload)
  return data
}

export const deleteAccountLoanStatus = async id => {
  const { data } = await apiClient.delete(`/account-loan-statuses/${id}`)
  return data
}
